import { useState } from "react";
import { Calendar } from "react-calendar";
import Modal from 'react-bootstrap/Modal';

function CalendarSearch({ onSearch, onCancel, showCalendarSearch }) {
    const [searchRange, setSearchRange] = useState([]);
    function onDateChange(range) {
        setSearchRange(range?.map(dateString => Date.parse(dateString) / 1000));
    }
    function onHideAndCancel() {
        onCancel()
    }
    return (
        <Modal className="calendar-popover" show={showCalendarSearch} onHide={e => onHideAndCancel()}>
            <Modal.Title>
                <h4>
                    Pick a start / end date for the search
                </h4>
            </Modal.Title>
            <div className="calendar-area">
                <Calendar selectRange={true} onChange={onDateChange} />
            </div>
            <Modal.Footer>
                <button onClick={e => onHideAndCancel()} className="btn btn-link">Cancel</button>
                <button onClick={e => onSearch(searchRange)} className="btn btn-norm" type="button">Search</button>
            </Modal.Footer>
        </Modal>
    );
}

export default CalendarSearch;